import { loadBurstPair, type FlowThemeDefinition } from '../../definition';
import { clockworkCardMotion } from './motion';
import { clockworkChromeTone } from './palette';

export const clockworkTheme: FlowThemeDefinition = {
  id: 'clockwork',
  label: 'Clockwork',
  description: 'Brass wheels click into a jewelled movement as the grand dial ticks round, until its iris opens onto a golden orrery.',
  category: 'playful',
  chromeTone: clockworkChromeTone,
  swatch: 'linear-gradient(135deg, #2A1C10 0%, #8A5E2A 36%, #E9BE70 50%, #1A1745 76%, #0B0C26 100%)',
  cardGlass: 'dense',
  cardMotion: clockworkCardMotion,
  burstSize: 300,
  softwareFriendly: false,
  loadScene: () => import('./scene').then((module) => module.createClockworkScene),
  loadBursts: () => loadBurstPair(import('./burst-step.json'), import('./burst-finale.json')),
};
